"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-11-03 13:50:35
 * @LastEditTime: 2021-11-25 10:28:51
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\Pie.ts
 */
exports.default = {
    color: ["#B69AED", "#6ABFF6", "#88E2D7", "#83D8AC", "#8393EF"],
    radius: ["30%", "50%"],
    center: ["50%", "50%"],
    minAngle: 1,
    itemStyle: {
        show: false,
        borderColor: "#fff",
        borderWidth: 2
    },
    label: {
        show: true,
        formatter: "{a|{b}}{b|{d}%}",
        rich: {
            a: {
                fontSize: 12,
                padding: [0, 2, 0, 4],
                color: "#788492"
            },
            b: {
                fontSize: 12,
                color: "auto"
            }
        }
    },
    labelLine: {
        show: true
    }
};
//# sourceMappingURL=Pie.js.map